import { ImNext2, ImPrevious2 } from "react-icons/im";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToPVCart, setActiveDesignIndex, setSelectedRequestId, setCartOpen } from "../../redux/pvDesign";
import CloseButton from "../general/CloseButton";
import { Button } from "react-bootstrap";

const PVDesignControls = () => {
  const dispatch = useDispatch(); 
  const { selectedRequestId, resultsByRequestId, activeDesignIndexByRequestId, cart } = useSelector((s) => s.pvDesign);
  if (!selectedRequestId) return null;

  const designs = resultsByRequestId[selectedRequestId] || [];
  const maxIdx = Math.max(0, designs.length - 1);
  const activeDesignIdx = Math.max(0, Math.min(activeDesignIndexByRequestId[selectedRequestId] || 0, maxIdx));
  const active = designs[activeDesignIdx];
  const cartId = `${selectedRequestId}:${active?.id}`;
  const isAlreadyInCart = !!cart.find((c) => c.id === cartId);

  return (
    <div className="pv-fixed-controls pv-anim-in">
      <Button
      variant="outline-secondary"
      onClick={() =>{
        dispatch(setActiveDesignIndex({ requestId: selectedRequestId, index: activeDesignIdx > 0 ? activeDesignIdx - 1 : maxIdx }))}} 
        className="pv-ui-btn" 
        aria-label="Previous"
        >
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <ImPrevious2 />
        Previous
        </div>
        </Button>
      <div className="pv-fixed-title">{active?.name || `Design ${activeDesignIdx + 1}`}</div>
      <Button 
      variant="outline-secondary"
      onClick={() =>{
        dispatch(setActiveDesignIndex({ requestId: selectedRequestId, index: activeDesignIdx < maxIdx ? activeDesignIdx + 1 : 0 }))}}
       className=" pv-ui-btn" aria-label="Next">
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        Next
        <ImNext2 />
        </div>
        </Button>
      {isAlreadyInCart ? (
        <span className="pv-chip pv-chip--added">Added</span>
      ) : (
        <Button
        variant="success"
          onClick={() => dispatch(addToPVCart({ id: cartId, requestId: selectedRequestId, designId: active?.id, name: active?.name }))}
          className="pv-ui-submit-btn"
        >
          Add to cart
        </Button>
      )}
      <CloseButton onClick={() => { 
        dispatch(setSelectedRequestId(null)); 
        dispatch(setCartOpen(false));
         }} size="sm" />
    </div>
  );
};

export default PVDesignControls;


